import gql from "graphql-tag";

export default gql`
  query {
    siloLocations {
      id
      name
      capacity
      sensor {
        id
        unit
        materialType
        lastMeasurement
      }
    }
  }
`;
